import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function NotFoundByLangPage() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  return (
    <div id="main">
      <p>{t('このページは存在しません。')}</p>
      <p>
        <Link to={`/${language}/login`}>{t('ログイン画面へ')}</Link>
      </p>
    </div>
  );
}

export default NotFoundByLangPage;
